import SideBarWrapper from "../../components/SideBarWrapper/SideBarWrapper";
import Projects from "./Projects";
import {useEffect, useState} from "react";
import {fetchProjects} from "../Workspace/DesignTab/utils";

export const ProjectList = () => {
    const [projects, setProjects] = useState([]);

    function refreshProjects (){
        fetchProjects().then(data => {
            if (data !== null)
                setProjects(data);
        });
    }
    useEffect(() => {
        refreshProjects();
    }, []);

    return (
        <SideBarWrapper>
            <Projects projects={projects} setProjects={setProjects} updateProjects={refreshProjects}/>
        </SideBarWrapper>
    )
}